import React from 'react';
import { Alert, Typography } from '@mui/material';
import { PlayerCardLayout } from '../../components/PlayerCardLayout';

export function StoppedPage({ header, reason }) {
  return (
    <PlayerCardLayout header={header}>
      <Alert severity="warning">Igra je zaustavljena.</Alert>
      <Typography>{reason}</Typography>
    </PlayerCardLayout>
  );
}
